<template>
  <simple-activity :show-header="false" :show-close-button="false">
    <b-container fluid class="p-0 m-0 justify-content-center">
      <b-row class="p-0 m-0">
        <b-col class="p-0 m-0">
          <b-container>
            <b-row class="justify-content-center mt-5">
              <b-col class="col-lg-6 col-12">
                <Chrome
                    id="input-color"
                    v-model="pickerColor"
                    @input="onChangeColor"
                    data-test-path="form-color-picker"
                ></Chrome>
              </b-col>

              <!--              HEX                 -->
              <b-col class="col-lg-6 col-12 px-1" style="margin-top: 100px">
                <div class="container mt-10">
                  <b-row>
                    <b-input-group
                        prepend="HEX"
                    >
                      <b-form-input
                          maxlength="7"
                          data-test-path="form-hex"
                          v-model="hex"
                          :value="hex"
                          @input="onChangeHEX"
                      ></b-form-input>
                    </b-input-group>
                  </b-row>

                  <!--              RGB                -->

                  <b-row>

                    <!--              R                -->
                    <b-col class="col-4 px-1 p-sm-3">
                      <b-input-group prepend="R" class="mt-3">
                        <b-form-input
                            data-test-path="form-r"
                            v-model="r"
                            :max="255"
                            :step="1"
                            :min="0"
                            type="number"
                            @input="onChangeR"
                        ></b-form-input>
                      </b-input-group>
                    </b-col>

                    <!--              G                -->
                    <b-col class="col-4 px-1 p-sm-3">
                      <b-input-group prepend="G" class="mt-3">
                        <b-form-input
                            data-test-path="form-g"
                            v-model="g"
                            :max="255"
                            :step="1"
                            :min="0"
                            type="number"
                            @input="onChangeG"
                        ></b-form-input>
                      </b-input-group>
                    </b-col>

                    <!--              B                -->
                    <b-col class="col-4 px-1 p-sm-3">
                      <b-input-group prepend="B" class="mt-3">
                        <b-form-input
                            data-test-path="form-b"
                            v-model="b"
                            :max="255"
                            :min="0"
                            :step="1"
                            type="number"
                            @input="onChangeB"
                        ></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <!--              PANTONE ZONE                -->

            <b-row class="justify-content-center mt-5">
              <b-col class="col-12 text-center">
                <h2 v-text="$tr('pantone.text','The closest matched pantone')"></h2></b-col>
              <b-col class="justify-content-center text-center"
                     style="height:130px; overflow:hidden">
                <b-row v-if="loading" no-gutters
                       style="max-height: 200px !important; justify-content: center">
                  <loading></loading>
                </b-row>

                <!--              COLOR BOX                -->
                <div class="mt-2 d-inline-block"
                     v-if="pantone.hex && !loading"
                     :style="'width: 120px; height: 120px;border-radius: 20px; background-color: ' + pantone.hex">
                </div>

                <!--              NO COLOR BOX                -->
                <div class="mt-2 d-inline-block"
                     v-if="!pantone.hex && !loading"
                     style="width: 110px; height: 120px; border-radius: 20px">
                  <font-awesome-icon
                      :icon="['fa-duotone', 'fa-square-xmark']"
                      style="font-size: 120px ; color: #00668B"/>
                </div>
              </b-col>
            </b-row>
            <b-container class="px-1 p-sm-3 p-md-5 p-lg-10">

              <!--              FAMILY                -->
              <b-row>
                <b-col class="px-1">
                  <b-input-group
                      :prepend="$tr('pantone.family','Family')"
                      class="mt-3"
                  >
                    <b-form-select
                        v-model="pantone.selectedFamily"
                        :options="families"
                        @change="onChangeFamily"
                        data-test-path="pantone-family"
                    ></b-form-select>
                  </b-input-group>
                </b-col>

                <!--              PANTONE                -->

                <b-col class="px-1">
                  <b-dropdown
                      :text="pantone.selectedPantone"
                      v-model="pantone.selectedPantone"
                      class="mt-3"
                      style="width: 100%; background-color: white!important"
                      data-test-path="pantone"
                  >
                    <div style="max-height: 400px; overflow-y: scroll; width: 100%!important">
                      <b-dropdown-item
                          v-for="pantone in filteredPantones"
                          :key="pantone.id"
                          @click="onChangePantone(pantone)"
                          style="min-width: 120px!important">
                        <div
                            :style="'border-radius: 5px; height: 20px; width: 20px; justify-content: center; display: inline-block; background-color: ' + pantone.hex">
                        </div>
                        {{ pantone.value }}
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                </b-col>
              </b-row>

              <!--              PANTONE HEX                -->

              <b-row>
                <b-col class="px-1">
                  <b-input-group
                      prepend="HEX"
                      class="mt-3"
                  >
                    <b-form-input
                        data-test-path="form-pantone-hex"
                        v-model="pantone.hex"
                        :value="pantone.hex"
                        readonly
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>

              <!--              PANTONE RGB                -->
              <b-row>

                <!--              PANTONE R               -->

                <b-col class="col-4 px-1 p-sm-3">
                  <b-input-group
                      prepend="R"
                      class="mt-3"
                  >
                    <b-form-input
                        data-test-path="form-pantone-r"
                        v-model="pantone.r"
                        :value="pantone.r"
                        readonly
                    ></b-form-input>
                  </b-input-group>
                </b-col>

                <!--              PANTONE G                -->

                <b-col class="col-4 px-1 p-sm-3">
                  <b-input-group
                      prepend="G"
                      class="mt-3"
                  >
                    <b-form-input
                        data-test-path="form-pantone-g"
                        v-model="pantone.g"
                        :value="pantone.g"
                        readonly
                    ></b-form-input>
                  </b-input-group>
                </b-col>

                <!--              PANTONE B                -->

                <b-col class="col-4 px-1 p-sm-3">
                  <b-input-group
                      prepend="B"
                      class="mt-3"
                  >
                    <b-form-input
                        data-test-path="form-pantone-b"
                        v-model="pantone.b"
                        :value="pantone.b"
                        readonly
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-container>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:footer>
      <CloseButton @close="close" v-if="!selectMode"></CloseButton>
      <footer-button type="Cancel" @cancel="close" v-if="selectMode"></footer-button>
      <footer-button type="Select" @select="select" v-if="selectMode" :disabled="!pantone.hex"></footer-button>
    </template>
  </simple-activity>
</template>
<script>
import Activity from "@/activity/Activity";
import ColorPickerRenderer from "@/components/forms/renderers/ColorPickerRenderer.vue";
import rpc from "@/Rpc";
import ColorBoxClass from "@/components/datagrid/ColorBoxClass.vue";
import {Chrome} from "vue-color";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import CloseButton from "@/components/navbar/CloseButton.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import GridActivity from "@/activity/templates/layouts/GridActivity.vue";
import Loading from "@/components/layout/Loading.vue";

export default {
  name: "PantoneActivity",
  components: {
    GridActivity,
    FooterNavbar,
    CloseButton,
    FooterButton,
    SimpleActivity,
    ColorBoxClass,
    Chrome,
    ColorPickerRenderer,
    Loading
  },

  async mounted() {
    this.families = await rpc.Pantone.pantoneFamilies();
    this.pantones = (await rpc.Pantone.listAll()).map(x => Object({
      id: x.pantone,
      value: x.pantone,
      text: x.pantone,
      family: x.family,
      hex: x.hex
    }));

    if (this.initialPantone) {
      let colorBackend = await rpc.Pantone.pantoneByName(this.initialPantone);

      if (colorBackend) {
        this.updateColorPicker(colorBackend);
        this.updatePantone(colorBackend);
        this.pantoneCorrect = true;
      }
    }
    this.filterPantones();
    this.loading = false;
  },
  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr("pantone", "Pantone");
    },

    filterPantones() {
      this.filteredPantones = this.pantones.filter(x => x.family.includes(this.pantone.selectedFamily));
    },

    async onChangeHEX(hex) {
      // Usuń znak '#' jeśli jest obecny
      hex = hex.replace(/^#/, '');

      // Dodaj znak '#' z powrotem na początku
      this.hex = '#' + hex;

      let bigint = parseInt(hex, 16);
      let r = (bigint >> 16) & 255;
      let g = (bigint >> 8) & 255;
      let b = bigint & 255;

      this.pickerColor = {
        rgba: {
          r: r,
          g: g,
          b: b
        }
      };
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await rpc.Pantone.pantoneByRGBInFamily(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b, this.pantone.selectedFamily);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      this.updatePantone(pantoneColor);
      this.updateRGB(this.pickerColor);
    },

    async onChangeFamily() {
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await rpc.Pantone.pantoneByRGBInFamily(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b, this.pantone.selectedFamily);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      this.updateColorPicker(pantoneColor);
      this.hex = pantoneColor.hex;
      this.updatePantone(pantoneColor);
      this.filterPantones();
    },

    async onChangePantone(pantone) {

      this.pantone.selectedPantone = pantone.value;
      let queryNumber = ++this.lastQuery;
      let colorBackend = await rpc.Pantone.pantoneByName(this.pantone.selectedPantone);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      this.updateColorPicker(colorBackend);
      this.updatePantone(colorBackend);
      this.hex = colorBackend.hex;
    },

    async onChangeR(r) {
      if (!r || r === '') {
        r = 0;
      }
      this.pickerColor = {
        rgba: {
          r: r,
          g: this.g,
          b: this.b
        }
      };
      this.hex = this.updateHex(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b);
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await rpc.Pantone.pantoneByRGBInFamily(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b, this.pantone.selectedFamily);
      this.updatePantone(pantoneColor);
      if (queryNumber !== this.lastQuery) {
        return;
      }
    },

    async onChangeG(g) {
      if (!g || g === '') {
        g = 0;
      }
      this.pickerColor = {
        rgba: {
          r: this.r,
          g: g,
          b: this.b
        }
      };


      this.hex = this.updateHex(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b);
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await rpc.Pantone.pantoneByRGBInFamily(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b, this.pantone.selectedFamily);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      this.updatePantone(pantoneColor);
    },

    async onChangeB(b) {
      if (!b || b === '') {
        b = 0;
      }
      this.pickerColor = {
        rgba: {
          r: this.r,
          g: this.g,
          b: b
        }
      };


      this.hex = this.updateHex(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b);
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await rpc.Pantone.pantoneByRGBInFamily(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b, this.pantone.selectedFamily);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      this.updatePantone(pantoneColor);
    },

    async onChangeColor() {
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await rpc.Pantone.pantoneByRGBInFamily(this.pickerColor.rgba.r, this.pickerColor.rgba.g, this.pickerColor.rgba.b, this.pantone.selectedFamily);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      this.updatePantone(pantoneColor);
      this.hex = this.pickerColor.hex;
      this.updateRGB(this.pickerColor);
    },

    updateRGB(color) {
      this.r = color.rgba.r;
      this.g = color.rgba.g;
      this.b = color.rgba.b;
    },

    updateColorPicker(color) {
      this.pickerColor = {
        rgba: {
          r: color.r,
          g: color.g,
          b: color.b,
        },
      };
      this.hex = this.pickerColor.hex;
      this.updateRGB(this.pickerColor);
    },

    updatePantone(color) {
      this.pantone.selectedPantone = color.pantone;
      this.pantone.hex = color.hex;
      this.pantone.r = color.r;
      this.pantone.g = color.g;
      this.pantone.b = color.b;
    },

    updateHex(r, g, b) {
      r = parseInt(r);
      g = parseInt(g);
      b = parseInt(b);

      if (isNaN(r)) r = 0;
      if (isNaN(g)) g = 0;
      if (isNaN(b)) b = 0;

      const rHex = r.toString(16).padStart(2, '0');
      const gHex = g.toString(16).padStart(2, '0');
      const bHex = b.toString(16).padStart(2, '0');

      return '#' + rHex + gHex + bHex;
    },

    select() {
      this.setResult({
        pantone: this.pantone.selectedPantone,
        hex: this.pantone.hex,
        r: this.pantone.r,
        g: this.pantone.g,
        b: this.pantone.b
      })
      this.close();
    }
  },

  props: {
    selectMode: {
      default:
          false
    },

    initialPantone: {
      default: ''
    }
  },

  data: function () {
    return {
      lastQuery: 0,
      loading: true,
      filteredPantones: [],
      pantoneCorrect: false,
      families: [],
      pantones: [],
      hex: '',
      r: 0,
      g: 0,
      b: 0,

      pickerColor: {
        hex: '',
        rgba: {
          r: 0,
          g: 0,
          b: 0
        },
      },

      pantone: {
        selectedFamily: 'Cotton',
        selectedPantone: '',
        hex: '',
        r: 0,
        g: 0,
        b: 0
      }
    }
  }
}

</script>
<style>
.vc-chrome-fields-wrap,
.vc-alpha-container,
.vc-alpha-picker,
.vc-alpha-gradient,
.vc-checkerboard,
.vc-chrome-color-wrap {
  display: none !important;
}

.vc-chrome {
  box-shadow: none !important;
}

.vc-chrome {
  width: 100% !important;
}
</style>